<template>
  <validation-provider
    rules="required"
    :name="'select-service'"
    v-slot="{ errors }"
    tag="div">
    <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
      <v-select
        class="w-100"
        :options="services"
        v-model="service_id"
        :reduce="service => service.id"
        :placeholder="$t('service.selectService')"
        label="code"
        :filterBy="filterByForServices"
        @search="debouncedFetchServices">
        <template slot="no-options">
          <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
          <template v-if="emptyResults">{{ $t('service.noServicesMatchingPhrase') }}&hellip;</template>
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.group_name }} - {{ option.name }}
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            {{ option.group_name }} - {{ option.name }}
          </div>
        </template>
      </v-select>
    </div>
  </validation-provider>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-service',
  props: [
    'serviceID'
  ],
  data () {
    return {
      service_id: 0,
      services: [],
      loadServicesError: false,
      emptyResults: false
    };
  },
  watch: {
    service_id (newValue) {
      this.$bus.$emit('ui-select-service-updated', newValue);
    }
  },
  mounted () {
    this.service_id = this.serviceID;
    this.prefetchServices(this.service_id);
  },
  methods: {
    filterByForServices (option, label, search) {
      return (option.code + ' ' + option.group_name + ' ' + option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    // eslint-disable-next-line
    debouncedFetchServices: debounce(function (searchPhrase, loadingCallback) {
      this.fetchServices(searchPhrase, loadingCallback);
    }, 500),
    fetchServices (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/services/items';
      let paramsData = {
        with: ['servicePrices']
      };

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.service_id !== 0 && this.service_id !== null && searchPhrase === '') {
        paramsData.ids = [this.service_id];
        endpointUrl = '/services/items-by-ids';
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'services',
        errorKey: 'loadServicesError',
        params: paramsData,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    prefetchServices (serviceID) {
      let endpointUrl = '/services/items-by-ids';
      let queryParams = {
        ids: [serviceID]
      };

      if (!serviceID) {
        endpointUrl = '/services/items';
        queryParams = {};
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'services',
        errorKey: 'loadServicesError',
        params: queryParams
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
